import React, { useEffect, useRef } from "react";
import { Avatar, Box, Typography } from "@mui/material";
import Message from "../Message";
import { getFormattedDateLabel } from "@/helpers/date.format";
import { dateSeparatorBoxSx, dateSeparatorLineSx, dateTextSx, messageContainerSx, typingAvatarSx, typingMessageSx } from "@/common/MessageStyles";

function MessagesContainer({ messages, role, otherUserTyping, chatUser, twoFactorEnabled = false, userRole }) {
  const messagesEndRef = useRef(null);
  let lastDateLabel = "";

  // Function to scroll to the bottom
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);
  
  return (
    <Box
      ref={messagesEndRef}
      sx={messageContainerSx}
    >
      {messages.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            minHeight: { xs: "200px", sm: "250px", md: "300px" },
            textAlign: "center",
            color: "#666",
            padding: { xs: "20px", sm: "30px", md: "40px" }
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
              fontWeight: 500,
              marginBottom: { xs: "8px", sm: "12px", md: "16px" },
              color: "#888"
            }}
          >
            No messages yet
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
              color: "#aaa",
              maxWidth: { xs: "280px", sm: "320px", md: "400px" }
            }}
          >
            Start a conversation by sending your first message
          </Typography>
        </Box>
      ) : (
        messages.map((msg, index) => {
          const dateLabel = getFormattedDateLabel(msg.createdAt || msg.timestamp);
          const showDateSeparator = dateLabel !== lastDateLabel;
          lastDateLabel = dateLabel;

          return (
            <React.Fragment key={msg.id}>
              {showDateSeparator && (
                <Box
                  sx={dateSeparatorBoxSx}
                >
                  <Box
                    sx={dateSeparatorLineSx}
                  />
                  <Typography
                    variant="caption"
                    sx={dateTextSx}
                  >
                    {dateLabel}
                  </Typography>
                  <Box
                    sx={{
                      flex: 1,
                      height: "1px",
                      backgroundColor: "#ccc",
                      mx: 1,
                    }}
                  />
                </Box>
              )}
              <Message msg={msg} role={role} twoFactorEnabled={twoFactorEnabled} userRole={userRole} />
            </React.Fragment>
          );
        })
      )}

      {otherUserTyping && (
        <Box display="flex" alignItems="center">
          <Avatar
            src={chatUser?.profile_picture?.file_url || "/default-icon.jpg"}
            alt={chatUser.first_name}
            sx={typingAvatarSx}
          />

          <Typography variant="body2" sx={typingMessageSx}>
            {chatUser.first_name} is typing...
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default MessagesContainer;
